import React from "react";

const PolicyDescription = props => {
  if (!props.productType) {
    return "";
  }
  let requiresSuffix =
    props.productType && !props.productType.endsWith(" Plan");

  if (!props.isSME) {
    return (
      <React.Fragment>
        My {props.productType}
        {requiresSuffix ? " " : ""}
        {requiresSuffix ? props.policyDescription : ""}
      </React.Fragment>
    );
  } else {
    return <React.Fragment>My Healthcare scheme</React.Fragment>;
  }
};

export default PolicyDescription;
